module.exports = __webpack_public_path__ + "img/jake.a0f2ca79.png";